import { Component } from '@angular/core';
import { BannerComponent } from '../components/banner/banner.component';
import { FormComponent } from '../components/form/form.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AppService } from '../services/app.service';
import { ApiService } from '../services/api.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-register',
    imports: [BannerComponent, FormComponent, TranslatePipe],
    templateUrl: './register.component.html',
    styleUrl: './register.component.scss'
})
export class RegisterComponent {
  
  private $appData: Subscription;
  data: any = {};
  constructor(private appService: AppService, private apiService: ApiService){
      this.$appData = this.apiService.$appData.subscribe((data: any) => { this.data = data });
  }

  ngAfterContentInit(){
    this.appService.addClickEvent()
  }

  ngOnInit(){
    let data = this.apiService.getData();
    this.data = data;
  }

  ngOnDestroy(): void {
    this.$appData.unsubscribe(); 
  }
}
